<template>
  <i-ant-design-usergroup-add-outlined />
</template>
